import { Link } from 'react-router-dom';

function DefaultView({device}) {
  return (
    <>
    <header>
      <h2>{device?.model?.name}</h2>
    </header>
    <section>
      <ul>
        {device?.model?.children?.map((child) => 
          <li key={`device-${child.id}`}>
            <span className={`device-icon ${child.type.toLowerCase()}`}></span>
            <Link to={child.id}>{child.name}</Link>
          </li>
        )}
      </ul>
    </section>
    </>
  )
}

export default DefaultView;
